 <template>
 <div v-role="'func'" style="margin:auto;width:1600px;margin-top:10px;">
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
 <div>
  <v-data-table
    :headers="headers"
    :items="definicoes"
    :search="searchInDb"
    :sort-desc="true"

    class="elevation-1"
   >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Bloqueio do Certificado
        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>
         <div class="flex-grow-1"></div>
         <v-row>
        <v-col v-if="!$store.state.hasMessage" class="text-center" cols="4" ><v-btn style="margin-top:15px;" x-large fab dark color="primary" @click="dialog=true">
              <v-icon dark>add</v-icon>
            </v-btn></v-col>
      </v-row>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>
<v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
              v-model="searchInDb"
              append-icon="search"
              label="Pesquisa"

              single-line
              hide-details
          ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="700px">

          <v-card>
            <v-overlay :value="overlay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
            <v-card-title>
              <span class="headline">Definir templo bloqueio</span>
               <v-progress-circular
                    v-if="progresso"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col cols="7" sm="7" md="7">
              <v-combobox
                v-model="editedItem.idinstituicao"
                :rules="obrigqtorioRules"
                item-value="idInstituicao"
                item-text="descricao"
                :items="instituicoes"
                filled
                outlined
                color="blue-grey lighten-2"
                label="Instituicao"
              ></v-combobox>
           </v-col>

           <v-col cols="5" sm="5" md="5">
              <template>

                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field

                      v-model="editedItem.databloqueio"
                      :rules="[v => !!v || 'Campo obrigatorio!']"
                      label="Data de bloqueio"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                </template>
                  <v-date-picker
                    ref="picker"

                    v-model="date"
                  max="2025-12-31"
                    min="1950-01-01"
                    @change="saveDate"
                  ></v-date-picker>
                </v-menu>
                </template>
           </v-col>
 
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="green darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="Guardar()"
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon color="green darken-3" size="25" @click="editItem(item)">edit</v-icon>
     </template>

      <template v-slot:item.estado="{ item }">
      <span :style="(item.estado >0)?'color:green;font-weight:bold':'color:red;font-weight:bold;'">{{(item.estado >0)?'Certificado disponível':'Certificado Bloqueado'}}</span>
     </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {
  directives: { mask },
  data: () => ({
    obrigqtorioRules: [value => !!value || 'campo obrigatorio'],
    ruleTextRequiredPagamento: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([.,0-9]))$/
        return !!pattern.test(value) || 'Invalido.'
      }
    ],
    ruleTelefone: [
      value => value.length === 9 || 'Minimo de caracteres exigido( 9 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    formValid: true,
    duplicated: false,
    comprovativo: 0,
    menu: false,
    searchInDb: '',
    date_: null,
    overlay: false,
    valid: true,
    sucess: false,
    dialog: false,
    err: false,
    isLoading: false,
    instituicoes: [],
    definicoes: [],
    emolumentos: [],
    anoLectivo: [],
    emolumentosAll: [],
    headers: [
      {text:'Instituição', value:'descricao'},
      {text:'Data bloqueio Certificado', value:'dataCertificadoDisponivel'},
      {text:'Estado', value:'estado'},
      {text:'Autor', value:'autor'},
    ],
    classes: [
       {id:1,descricao:'10ª Classe'},
       {id:2,descricao:'11ª Classe'},
       {id:3,descricao:'12ª Classe'},
       {id:4,descricao:'13ª Classe'},
    ],
    formaPagamentos: [],
    bancos: [],
    editedItem: {
      databloqueio:'',
      pkpagamentoEmolumento: 0,
      nome: '',
      idanoLectivo: 0,
      Ordem_deposito: '',
      pagamento: 0,
      quantidade: 0,
      preco: 0,
      fkEmolumentos: 0,
      idinstituicao: 0,
      instituicaodescricao: '',
      resto: 0,
      pkcomprovativo_pagamento: 0,
      formaPagamento: 0,
      num_Deposito: '',
      banco: '',
      data_deposito: '',
      quantidade:'',
      classe:''

    },
    defaultItem: {
      databloqueio:'',
      pkpagamentoEmolumento: 0,
      nome: '',
      anolectivo: 0,
      Ordem_deposito: '',
      pagamento: 0,
      quantidade: 0,
      preco: 0,
      fkEmolumentos: 0,
      idinstituicao: 0,
      instituicaodescricao: '',
      resto: 0,
      pkcomprovativo_pagamento: 0,
      formaPagamento: 0,
      num_Deposito: '',
      banco: '',
      data_deposito: '',
      quantidade:'',
      classe:''

    }
  }),

  watch: {
     menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },

  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlgêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {
     this.initialize()
   },

  methods: {

    close () {
      this.editedItem = this.defaultItem
      this.dialog = false
    },

    async initializebanco () {
      this.isLoading = true
      try {
        this.bancos = await axios
          .get('/listarbancos')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.databloqueio = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },


  async  Guardar () {

    if (this.$refs.form.validate()) {
      this.overlay = true
      try {

        let params = 
        {
          instituicao: this.editedItem.idinstituicao,
          dataBloqueio: this.editedItem.databloqueio,
         }


        let result = await axios.post('/definirTempoBloqueioCertificado',params).then((res)=>res.data)
        if( result.affectedRows >= 1 ){
          this.overlay = false
          this.close()
          this.$store.dispatch('textMessage', { msg: 'Definição de tempo de abertura feita com sucesso.',classMessage: 'msgSucess',timeout: 3000})
          this.initialize()
        }      
      } catch (error) {
        this.overlay = false
        this.$store.dispatch('textMessage', { msg: 'Ocorreu um erro ao tentar efectuar a operação.',classMessage: 'msgError',timeout: 3000})
      }
    }

  },

    async initializeformapagamento () {
      this.isLoading = true
      try {
        this.formaPagamentos = await axios
          .get('/listarformapagamentos')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initialize (searchInDb) {

      if (!searchInDb) {
          var payload = "all"
        } else {
          var payload =  searchInDb
        }


      this.isLoading = true
      try {
        this.instituicoes = await axios.get('/anoLectivoInstituicao').then(res => res.data)
        this.definicoes = await axios.get('/getInstituicaotempocertificado/'+payload).then((res)=>res.data)
         this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire()
      }
    },
    filterAnoLectivo (idinstituicao) {
      this.editedItem.idanoLectivo = this.instituicoes.filter(t => t.idInstituicao === idinstituicao)[0].anolectivo
      this.editedItem.instituicaodescricao = this.instituicoes.filter(t => t.idInstituicao === idinstituicao)[0].descricao
    },
    async initializeEmolumentos (search) {
      this.isLoading = true
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }

        this.emolumentos = await axios
          .get('/emolumentosAll/' + payload)
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    preco (pkemolumento) {
      this.editedItem.preco = this.emolumentos.filter(t => t.pkemolumentos === pkemolumento)[0].preco
      this.editedItem.nome = this.emolumentos.filter(t => t.pkemolumentos === pkemolumento)[0].nome
    },
    quantidadeEmolumento () {
      if (this.editedItem.pagamento) {
        this.editedItem.quantidade = parseInt(this.editedItem.pagamento / this.editedItem.preco)
        this.editedItem.resto = (this.editedItem.pagamento % this.editedItem.preco)
        this.editedItem.consumo = 0
      } else { this.editedItem.quantidade = 0 }
    },
    async addComprovativo () {
      let params =
       {
         pkcomprovativo_pagamento: 0,
         fkFormaPagamento: this.editedItem.formaPagamento.pkforma_pagamento,
         num_Deposito: this.editedItem.Ordem_deposito,
         idbanco: this.editedItem.banco.pkbanco,
         bancodescricao: this.editedItem.banco.descricao,
         data_deposito: this.date_,
         idpessoa: ls.get('idPessoa')
       }

      try {
        this.isLoading = true
        this.comprovativo = await axios
          .post('/comprovativopagamentoInsertOrUpdate', params)
          .then(res => res.data)

        this.isLoading = false
        this.text = this.comprovativo.data
        if (this.comprovativo.data.includes('sucesso')) {
          this.save(this.comprovativo.result[0].id)
          this.sucess = true
          this.text = this.comprovativo.result.length + ' gravado(s) com sucesso'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })
          this.sucess = true
          setTimeout(() => {
            this.sucess = false
          }, 2000)
        } else
        if (this.comprovativo.data.includes('existente')) {
          this.text = this.comprovativo.data
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
          this.duplicated = true
          setTimeout(() => {
            this.duplicated = false
          }, 5000)
        }
      } catch (error) {
        this.err = true
        console.log('eroooo: ' + error)
        this.isLoading = false
        this.text = error.message
        setTimeout(() => {
          this.err = false
        }, 5000)
      }
      this.$store.dispatch('textMessage', {
        msg: this.text,
        classMessage: 'msgError',
        timeout: 8000
      })
    },

    async save (idComprovativo) {
      this.isLoading = true
      if (this.editedItem.idinstituicao && this.editedItem.fkEmolumentos && this.editedItem.pagamento && this.editedItem.Ordem_deposito) {
        var params = {
          num_Deposito: this.editedItem.Ordem_deposito,
          fkEmolumentos: this.editedItem.fkEmolumentos,
          tipo_emolumento: this.editedItem.nome,
          pagamento: this.editedItem.pagamento,
          anoLectivo: this.editedItem.idanoLectivo,
          quantidade_inicial: this.editedItem.quantidade,
          idinstituicao: this.editedItem.idinstituicao,
          instituicao: this.editedItem.instituicaodescricao,
          resto: this.editedItem.resto,
          preco: this.editedItem.preco,
          autor: ls.get('idPessoa'),
          comprovativo: idComprovativo
        }

        try {
          let msg = await axios
            .post('/InsertPagarEmolumento', params)
            .then(res => res.data)
          this.isLoading = false
          this.text = msg
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })

          try {
            if (msg.affectedRows >= 1) {
              this.text = ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
              this.sucess = true
              setTimeout(() => {
                this.sucess = false
                this.$router.push('/listarpagamentoemolumento')
              }, 2000)
            }
          } catch (error) {
            this.isLoading = false
            this.err = true
            setTimeout(() => {
              this.err = false
            }, 2000)
            this.text = error.message
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } finally {
            this.editedItem = this.defaultItem
            this.isLoading = false
          }
        } catch (error) {}
      } else this.isLoading = false
    }
  }
}

</script>
